import { Player } from "@lottiefiles/react-lottie-player";
// import waveGirl from "../../../public/assets/Waving_Girl.json"; // Place the JSON file in your assets folder
const workingGirl = "/assets/working_girl.json";
export default function WorkingGirl() {
  return (
    // <div className="w-32 md:w-40 bg-orange-50 p-4 rounded-xl shadow-lg w-fit">
    <div
    //className="bg-gradient-to-r from-orange-100 via-white to-orange-100 p-4 rounded-full shadow-lg w-fit"
    >
      {/* // <div className="bg-gradient-to-r from-primary via-white to-primary shadow-lg w-fit"> */}
      <Player
        autoplay
        loop
        src={workingGirl}
        style={{ height: "100%", width: "100%" }}
        //className="w-90 h-32"
      />
    </div>
  );
}
